var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-unused-vars */
import { TextField } from '@material-ui/core';
import { fieldToTextField } from 'formik-material-ui';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
var customFormikMUITextField = function (props, ref) {
    var inputRef = useRef();
    useImperativeHandle(ref, function () { return ({
        updateValue: function (value) {
            props.form.setFieldTouched(props.field.name, true);
            props.form.setFieldValue(props.field.name, value);
        },
        value: inputRef.current.value
    }); });
    return React.createElement(TextField, __assign({ inputRef: inputRef }, fieldToTextField(props)));
};
export var CustomFormikMUITextField = forwardRef(customFormikMUITextField);
//# sourceMappingURL=CustomFormikMUITextField.js.map